var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntlPhoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6875 1.67188L9.5625 6.17188C9.89062 6.92188 9.70312 7.8125 9.04688 8.32812L6.75 10.25C8.29688 13.5312 10.9688 16.2031 14.25 17.75L16.1719 15.4531C16.6875 14.7969 17.5781 14.6094 18.3281 14.9375L22.8281 16.8125C23.7188 17.1406 24.1406 18.125 23.9062 19.0156L22.7812 23.1406C22.5469 23.9375 21.8438 24.5 21 24.5C9.375 24.5 0 15.125 0 3.5C0 2.65625 0.5625 1.95312 1.35938 1.71875L5.48438 0.59375C6.375 0.359375 7.35938 0.78125 7.6875 1.67188Z",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntlPhoneLogo);
export default __webpack_public_path__ + "static/media/intl-phoneLogo.bdc958d98096866a65e423835077ff25.svg";
export { ForwardRef as ReactComponent };